<template>
  <div class="main-wrapper">
    <header>
      <Header />
    </header>
    <Hero />
    <main>
      <router-view />
    </main>
    <footer>
      <Footer />
    </footer>
  </div>
</template>

<script>
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import Hero from './components/hero.vue'


export default {
  components: {
    Header,
    Footer,
    Hero
  }    
}
</script>

<style lang="scss">
  html, body {
    margin: 0;
    padding: 0;
    height: 100vh;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  .main-wrapper {
    position: relative;
    min-height: 100vh;
  }

  main {
    // min-height: calc(100vh - 280px);
    margin: auto;
    padding-bottom: 60px;
  }

  .content {
      padding: 50px 20%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;

      @media only screen and (max-width: 750px) {
        padding: 10px;
      }
  }

</style>
